import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { AvailableSchedulePeriod } from '../../../models/schedule-calendar.models';
import { ScheduleAddAvailableTimesFormComponent } from '../../forms/schedule-add-available-times-form/schedule-add-available-times-form.component';

@Component({
  selector: 'app-schedule-add-available-times',
  templateUrl: './schedule-add-available-times.component.html',
  styleUrls: ['./schedule-add-available-times.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatCardModule, ScheduleAddAvailableTimesFormComponent],
})
export class ScheduleAddAvailableTimesComponent {
  readonly allowWeekends = input(false);
  readonly timezoneName = input<string>();
  readonly disabled = input(false);

  readonly addTimes = output<AvailableSchedulePeriod[]>();
}
